module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.person) ? _c('div', {
    staticClass: "g-person-merz__wrapper",
    class: _vm.modusOption ? (_vm.modusOption.key.replace('b_', '') + 'smodus') : 'default'
  }, [_vm._l((_vm.person.merzItems1), function(it, pi) {
    return [_c('div', {
      key: pi,
      staticClass: "ksm-flex-1"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(it.merz.name.trim().replace('Merz', 'Merz ')) + "   ")]), _vm._v(" "), _vm._l((it.seiten), function(it2, pi2) {
      return [_vm._v("\n        " + _vm._s(pi2 > 0 ? ' •' : '') + "\n        "), _c('a', {
        key: 's' + pi2,
        class: _vm.isSeiteSelected(it, it2, _vm.person.lemmaID) ? 'ksm-acco-person-expand' : '',
        on: {
          "click": function($event) {
            return _vm.toPath(it, it2, _vm.person.lemmaID)
          }
        }
      }, [_vm._v(_vm._s(it2.name.length > 20 ? it2.name : it2.name.replace(/\s/g, ' ')))])]
    })], 2)]
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2160b31f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/g_plugin/comps/PersonMerz.vue
// module id = 1957
// module chunks = 1